(function () {
  'use strict';

  angular.module('app.response-to-intervention-analytics.teacher-details', []);

})();
